import { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import SubmitForm from "../../../components/SubmitForm";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import InputGeral from "../../../components/InputGeral/Index";
import { toast } from "react-toastify";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";

import ConsultaTipoSolicitacaoPagamento from "../../../../lib/json/consultas/TipoSolicitacao.json"
import ConsultaTipoTitulo from "../../../../lib/json/consultas/TipoTitulo.json"
import ConsultaNatureza from "../../../../lib/json/consultas/Natureza.json"
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"

import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectNatureza from "../../../components/Select/Natureza";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectFixo from "../../../components/SelectFixo";

function FichaTipoSolicitacaoPagamento(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');

    const ConsultaPadraoTipo = ConsultaTipoTitulo.consulta + " AND X5_FILIAL = FILIAL(SX5) "
    const ConsultaPadraoNatureza = ConsultaNatureza.consulta + " WHERE D_E_L_E_T_ <> '*' AND ED_FILIAL = FILIAL(SED) AND ED_MSBLQL <> '1' AND ED_TIPO = '2' "
    const ConsultaPadraoCentroCusto = ConsultaCentroCusto.consulta + " WHERE CTT.D_E_L_E_T_ <> '*' AND CTT_FILIAL = FILIAL(CTT) "

    const { idTipoSolicitacaoPagamento, empresaFilialFinanceiro } = useParams();

    const consultaDefault  = ConsultaTipoSolicitacaoPagamento.consulta + (idTipoSolicitacaoPagamento ? ` AND PSC_FILIAL = FILIAL(PSC) AND PSC_ID = '${idTipoSolicitacaoPagamento}'` : '');

    const [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
        
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialFinanceiro);
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialFinanceiro);
    const [campoNumero, setCampoNumero] = useState();
    const [campoDescricao, setCampoDescricao] = useState("");
    const [campoPrefixo, setCampoPrefixo] = useState("");
    const [campoNumeroTitulo, setCampoNumeroTitulo] = useState({value: "S", text: "Sim"});
    const [campoTipoTitulo, setTipoTitulo] = useState()
    const [campoNatureza, setCampoNatureza] = useState()
    const [campoCentroCusto, setCampoCentroCusto] = useState()
    
    
    useEffect( () => {
        const fetchData = async() => {
            if (idTipoSolicitacaoPagamento){
                const retornaAcesso = await loadTipoSolicitacaoPagamento()

                if (!retornaAcesso) {
                    ErroMsg("Não encontrado ou Usuário não tem Permissão de Acesso!");
                    navigate('/financeiro/TipoSolicitacaoPagamento');
                }
            }
        }

        fetchData()
    }, []);

    const loadTipoSolicitacaoPagamento = async() => {
        setCarregar(true);
        let lRetorno = true;
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaTipoSolicitacaoPagamento.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
                
        if (retConsulta.data && retConsulta.data.length > 0){
            const { PSC_ID, PSC_DESC, PSC_CC, PSC_NATUR, PSC_TIPO, PSC_PREFIX, PSC_NUMTIT } = retConsulta.data[0]
            
            const Natureza = PSC_NATUR.trim()
            const CentroCusto = PSC_CC.trim()

            setCampoNumero(PSC_ID)
            setCampoDescricao(PSC_DESC)
            setCampoPrefixo(PSC_PREFIX)
            setCampoNumeroTitulo({value: (PSC_NUMTIT == 'S' ? 'S' : 'N' ), text: ( PSC_NUMTIT == 'S' ? "Sim" : "Não" )})
            setTipoTitulo({value: PSC_TIPO.padEnd(6, ' '), label: "" })
            
            if (Natureza){
                if (Natureza.includes(';')){
                    const NatAux = Natureza.split(';')
                    const NatValue = NatAux.map( (item) => { return {value: item.trim().padEnd(10, ' '), label: "" } } )
                    setCampoNatureza(NatValue)
                }else{
                    setCampoNatureza([{value: Natureza.padEnd(10, ' '), label: "" }])
                }
            }

            if (CentroCusto){
                if (CentroCusto.includes(';')){
                    const CCAux = CentroCusto.split(';')
                    const CCValue = CCAux.map( (item) => { return {value: item.trim().padEnd(20, " "), label: "" } } )
                    setCampoCentroCusto(CCValue)
                }else{
                    setCampoCentroCusto([{value: CentroCusto.padEnd(20, " "), label: "" }])
                }
            }
        }else{
            lRetorno = false;
        }

        setCarregar(false);

        return lRetorno
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    const handleSalvar = async() =>{
        let oRetorno
        if (!campoDescricao) {
            toast.warning('Preencha a Descrição do Tipo de Solicitação de Pagamento.');
            return false;
        }
        if (!campoPrefixo) {
            toast.warning('Preencha o Prefixo do Tipo de Solicitação de Pagamento.');
            return false;
        }

        const cJSONSalvar = {
            PSC_ID: campoNumero,
            PSC_DESC: campoDescricao,         
            PSC_PREFIX: campoPrefixo,
            PSC_NUMTIT: campoNumeroTitulo,
            PSC_TIPO: campoTipoTitulo,
            PSC_NATUR: (campoNatureza ? campoNatureza.map((item) => item.value).join(';') : "" ),
            PSC_CC: (campoCentroCusto ? campoCentroCusto.map((item) => item.value).join(';') : "" ),
        }

        setCarregar(true)

        if (idTipoSolicitacaoPagamento){
            oRetorno = await ConsumoTOTVS_POST('ALTERARTIPOSOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
        }else{
            oRetorno = await ConsumoTOTVS_POST('NOVOTIPOSOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error == '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false
        }        

        return true
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Tipo de Solicitação de Pagamento" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Numero"
                                placeholder="Numero"
                                tipo="text"
                                value={campoNumero}
                                onChange={(e) => setCampoNumero(e)}
                                disabled={true}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Descrição"
                                placeholder="Descrição"
                                tipo="text"
                                value={campoDescricao}
                                onChange={(e) => setCampoDescricao(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Prefixo"
                                placeholder="Prefixo"
                                tipo="text"
                                value={campoPrefixo}
                                onChange={(e) => setCampoPrefixo(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <SelectFixo
                                options={[{value:'S', text:'Sim'},{value:'N', text:'Não'}]} 
                                value={campoNumeroTitulo} 
                                selectedOptionValue={campoNumeroTitulo} 
                                isLabel={true} 
                                label="Preenche Número Título" 
                                onChange={(e) => setCampoNumeroTitulo(e)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectDinamico
                                label={"Tipo Título"}
                                disabled={disabledForm}
                                EmpresaLogada={empresaFilial}
                                consulta={ConsultaPadraoTipo}
                                tabela={ConsultaTipoTitulo.tabelas}
                                cText="X5_CHAVE + ' - ' + item.X5_DESCRI"
                                cValue="X5_CHAVE"
                                campoValue={campoTipoTitulo}
                                onchange={(e) => setTipoTitulo(e)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectNatureza
                                campoNatureza={campoNatureza}
                                changeNatureza={setCampoNatureza}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                                queryNatureza={ConsultaPadraoNatureza}
                                isMultiplo={true}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectCentroCusto
                                campoCentroCusto={campoCentroCusto}
                                changeCentroCusto={setCampoCentroCusto}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                                queryCentroCusto={ConsultaPadraoCentroCusto}
                                isMultiplo={true}
                            />
                        </Col>
                    </Row>
                </>
            )}
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : 'handleVoltar'}
                onVoltar={ disabledForm ? 'handleVoltar' : null}
            />
            
        </>
    );
}

export default FichaTipoSolicitacaoPagamento;